/** 1-based row index for paginated list tables */
export function listRowNumber(page: number, index: number, limit: number): number {
  return (page - 1) * limit + index + 1;
}

export const LIST_TABLE_CLASS = 'w-full min-w-full border-collapse';

export const LIST_THEAD_CLASS = 'bg-subtle sticky top-0 z-10';

export const LIST_TBODY_CLASS = 'bg-card divide-y divide-line';

export const LIST_TH_CLASS =
  'px-5 py-3.5 text-left text-[10px] font-bold text-muted uppercase tracking-widest border-r border-line last:border-r-0 bg-subtle whitespace-nowrap';

export const LIST_TD_CLASS =
  'px-5 py-3.5 align-middle border-r border-line last:border-r-0 text-sm';

export const LIST_TH_NO_CLASS = `${LIST_TH_CLASS} w-14 text-center`;

export const LIST_TD_NO_CLASS = `${LIST_TD_CLASS} whitespace-nowrap text-center font-medium text-muted tabular-nums`;

/** Icon-only row action — eye / view detail */
export const LIST_EYE_BTN_CLASS =
  'inline-flex items-center justify-center p-2 bg-indigo-500/10 hover:bg-indigo-500/15 text-indigo-700 border border-indigo-200/60 rounded-lg transition-all';
